// src/routes/RoleProtectedRoute.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUserData } from '../redux/auth/authSelector';
import { hasRoutePermission, DEFAULT_ROUTES } from '../config/rolePermissions';
import { isAuthenticated } from './utils/authUtils';

const RoleProtectedRoute = ({ children }) => {
  const userData = useSelector(selectUserData);
  const location = useLocation();
  
  // Check authentication via localStorage token
  const isAuth = isAuthenticated();
  const userRole = userData?.role_name;

  console.log("RoleProtectedRoute Check:", {
    isAuthenticated: isAuth,
    userData,
    userRole,
    currentPath: location.pathname
  });

  // CRITICAL: First check authentication via token
  if (!isAuth) {
    console.log("No auth token - redirecting to login");
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Second check: Must have userData
  if (!userData || !userRole) {
    console.log("No user data - redirecting to login");
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Get current path without leading slash
  const currentPath = location.pathname.replace(/^\/+/, '');
  
  // Third check: Must have permission for this route
  const hasPermission = hasRoutePermission(userRole, currentPath);
  
  console.log("Permission check:", {
    userRole,
    currentPath,
    hasPermission
  });

  if (!hasPermission) {
    console.log("No permission - redirecting to default route");
    const defaultRoute = DEFAULT_ROUTES[userRole] || '/login';
    return <Navigate to={defaultRoute} replace />;
  }

  // All checks passed
  return children;
};

export default RoleProtectedRoute;